"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");
/**
 * Simple user info.
 * @author Radek Beran
 */


var UserInfo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(UserInfo, _DomainObject_1$Domai);

  function UserInfo(id, name) {
    var _this;

    _classCallCheck(this, UserInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserInfo).call(this));
    _this.id = id;
    _this.name = name;
    return _this;
  }

  _createClass(UserInfo, [{
    key: "getFirstName",
    value: function getFirstName() {
      if (this.name === null) {
        return null;
      }

      var spaceIndex = this.name.indexOf(' ');

      if (spaceIndex > 0) {
        return this.name.substr(0, spaceIndex);
      }

      return this.name;
    }
  }, {
    key: "getLastName",
    value: function getLastName() {
      if (this.name === null) {
        return null;
      }

      var spaceIndex = this.name.indexOf(' ');

      if (spaceIndex > 0) {
        return this.name.substr(spaceIndex + 1);
      }

      return this.name;
    }
    /**
     * Converter from data-dictionary representation
     */

  }], [{
    key: "empty",
    value: function empty() {
      return new UserInfo(utils_1.Utils.VOID_ID, 'no-name');
    }
  }, {
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new UserInfo(mat.id, mat.name);
    }
  }]);

  return UserInfo;
}(DomainObject_1.DomainObject);

exports.UserInfo = UserInfo;

UserInfo.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(UserInfo.name);
  return {
    id: builder.id('id'),
    name: builder.opt(builder.str('name'))
  };
}();